import React from 'react';
import Modal from './Modal';

const ConfirmDialog = (props) => {
  const {
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    danger,
  } = props;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title || 'Confirm Action'} size="sm">
      <div className="flex flex-col items-center text-center py-2">
        <div
          className={
            'w-12 h-12 rounded-full flex items-center justify-center mb-4 ' +
            (danger ? 'bg-red-100' : 'bg-yellow-100')
          }
        >
          <span className="text-2xl">{danger ? '⚠️' : '❓'}</span>
        </div>
        <p className="text-gray-600 mb-6">
          {message || 'Are you sure you want to proceed?'}
        </p>
        <div className="flex gap-3 w-full">
          <button
            onClick={onClose}
            className="flex-1 font-medium py-2 px-4 rounded-lg border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 transition-colors duration-200"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className={
              'flex-1 font-medium py-2 px-4 rounded-lg transition-colors duration-200 text-white ' +
              (danger
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-blue-600 hover:bg-blue-700')
            }
          >
            {confirmText || 'Confirm'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;